export enum TILE_TYPES {
  BEHAVIOUR = "BEHAVIOUR",
  SYSTEM_HEALTH = "SYSTEM_HEALTH",
  HEALTH_METRICS = "HEALTH_METRICS",
}